import { Guid } from '@fitscovery/common/types';
import { Event } from '../models';

export namespace EventsActions {

  export class GetEventById {
    static readonly type = '[Event] GetEventById';
    constructor(public eventId: string) { }
  }

  export class GetEventsBySubdomain {
    static readonly type = '[Event] GetEventsBySubdomain';
    constructor(public subdomain: string) { }
  }
  
  export class CreateEvent {
    static readonly type = '[Event] CreateEvent';
    constructor(public event: Event) { }
  }
  
  export class UpdateEvent {
    static readonly type = '[Event] UpdateEvent';
    constructor(public event: Event) { }
  }
  
  export class DuplicateEvent {
    static readonly type = '[Event] DuplicateEvent';
    constructor(public event: Event) { }
  }
  
  export class DeleteEvent {
    static readonly type = '[Event] DeleteEvent';
    constructor(public eventId: Guid, public partnerId: Guid) { }
  }
  
  export class GetAttendeesWithIdByEventId {
    static readonly type = '[Event] GetAttendeesWithIdByEventId';
    constructor(public eventId: Guid) { }
  }
  
  export class AddEventAttendees {
    static readonly type = '[Event] AddEventAttendees';
    constructor(public eventId: Guid, public userList: Guid[]) { }
  }
  
  export class UpdateEventAttendee {
    static readonly type = '[Event] UpdateEventAttendee';
    constructor(public userId: Guid, public partnerId: Guid, public eventId: Guid, public isPresent: boolean) { }
  }
  
  export class UpdateAllEventAttendee {
    static readonly type = '[Event] UpdateAllEventAttendee';
    constructor(public partnerId: Guid, public eventId: Guid, public isPresent: boolean) { }
  }
  
  export class DownloadCsvEventAttendees {
    static readonly type = '[Event] DownloadCsvEventAttendees';
    constructor(public eventId: Guid, public partnerId: Guid) { }
  }

  export class BookNow {
    static readonly type = '[Event] BookNow';
    constructor(public eventId: Guid, public quantity: number) { }
  }

  export class SoftReserve {
    static readonly type = '[Event] SoftReserve';
    constructor(public eventId: Guid) { }
  }

  export class CancelFreeEventSlot {
    static readonly type = '[Event] CancelFreeEventSlot';
    constructor(public eventId: Guid) { }
  }

  export class CancelEventSlot {
    static readonly type = '[Event] CancelEventSlot';
    constructor(public eventId: Guid) { }
  }

  export class RemoveSelectedEvent {
    static readonly type = '[Event] RemoveSelectedEvent';
    constructor() { }
  }

  export class RemoveSelectedEventAttendees {
    static readonly type = '[Event] RemoveSelectedEventAttendees';
    constructor() { }
  }

}
